<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  @if (udid()) {
    <!-- Result -->
    <app-ios-udid-finder-result-section
      [udid]="udid()"
      [deviceName]="deviceName()"
      [imei]="imei()"
      [meid]="meid()"
      [serial]="serial()"
      [version]="version()"
      [product]="product()"
    />
  } @else {
    <!-- Hero -->
    <app-ios-udid-finder-hero-section />
  }
  <!-- Info -->
  <app-ios-udid-finder-info-section />
  <!-- FAQ -->
  <app-ios-udid-finder-faq-section />
  <!-- CTA -->
  <app-cta-section id="cta" />
</div>
